import ApiPaths from "./ApiPaths";
import { httpService } from "./HttpService";
import axios from 'axios';

export const sendContactForm = async (name: string, email: string, message: string) => {
    try {
        const response = await httpService.post(ApiPaths.CONTACT, {
            name,
            email,
            message
        });
        return response.data; // Return the response data
    } catch (error) {
        let errorMessage = 'Unexpected error happened, try again later.';
        if (axios.isAxiosError(error)) {
            // Extract user-friendly error message from the response
            errorMessage = error.response?.data?.userMessage || 
                                    error.response?.data?.detail || 
                                    errorMessage;
        }

        throw new Error(errorMessage);
    }
};